import React, { Component } from "react";
import { withAuth0 } from "@auth0/auth0-react";
import {Badge, DropdownItem, DropdownMenu, DropdownToggle, Label, Nav, NavItem, NavLink} from "reactstrap";
import PropTypes from "prop-types";

import { AppAsideToggler, AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from "@coreui/react";
import logo from "../../assets/img/brand/img-scanlife-logo.png"
import favicon from "../../assets/img/brand/favicon.ico"
import CookieNew from "universal-cookie";
import {Link} from "react-router-dom";
import {configurationFile} from "../../utils/config";
const {LOGOUT_URL} = configurationFile[process.env["REACT_APP_ENV"]];


const cookies= new CookieNew();

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultHeader extends Component {
  render() {
    const {isAuthenticated, user} = this.props.auth0;
    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    const doLogout = () => {
      cookies.remove("JSESSIONID");
      cookies.remove("useremail");
      cookies.remove("x-sb-context");
      window.location.href = LOGOUT_URL;
    }

    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <AppNavbarBrand
          full={{ src: logo, width: 150, height: 40, alt: "CoreUI Logo" }}
          minimized={{ src: favicon, width: 40, height: 40, alt: "CoreUI Logo" }}
        />
        <AppSidebarToggler className="d-md-down-none" display="lg" />

        <Nav className="d-md-down-none" navbar>
          <NavItem className="px-3">
            <NavLink href="/">Home</NavLink>
          </NavItem>
        </Nav>
        <Nav className="ml-auto" navbar>
          {/*<NavItem className="d-md-down-none">*/}
          {/*  <NavLink href="#"><i className="icon-bell"></i><Badge pill color="danger">5</Badge></NavLink>*/}
          {/*</NavItem>*/}
          {/*<NavItem className="d-md-down-none">*/}
          {/*  <NavLink href="#"><i className="icon-list"></i></NavLink>*/}
          {/*</NavItem>*/}
          {/*<NavItem className="d-md-down-none">*/}
          {/*  <NavLink href="#"><i className="icon-location-pin"></i></NavLink>*/}
          {/*</NavItem>*/}
          <AppHeaderDropdown direction="down">
            <DropdownToggle nav>
              <img src={user && user.picture} className="img-avatar" alt="platform-support@scanbuy.com" />
            </DropdownToggle>
            <DropdownMenu right style={{ right: "auto" }}>
              {/*<DropdownItem header tag="div" className="text-center"><strong>Account</strong></DropdownItem>*/}
              {/*<DropdownItem><i className="fa fa-bell-o"></i> Updates<Badge color="info">42</Badge></DropdownItem>*/}
              {/*<DropdownItem><i className="fa fa-envelope-o"></i> Messages<Badge color="success">42</Badge></DropdownItem>*/}
              {/*<DropdownItem><i className="fa fa-tasks"></i> Tasks<Badge color="danger">42</Badge></DropdownItem>*/}
              {/*<DropdownItem><i className="fa fa-comments"></i> Comments<Badge color="warning">42</Badge></DropdownItem>*/}
              {/*<DropdownItem header tag="div" className="text-center"><strong>Settings</strong></DropdownItem>*/}
              {isAuthenticated && <DropdownItem tag={Link} to="/app/profile/edit"><i className="fa fa-user"></i> Profile</DropdownItem>}
              {/*<DropdownItem><i className="fa fa-wrench"></i> Settings</DropdownItem>*/}
              {/*<DropdownItem><i className="fa fa-usd"></i> Payments<Badge color="secondary">42</Badge></DropdownItem>*/}
              {/*<DropdownItem><i className="fa fa-file"></i> Projects<Badge color="primary">42</Badge></DropdownItem>*/}
              {/*<DropdownItem divider />*/}
              {/*<DropdownItem><i className="fa fa-shield"></i> Lock Account</DropdownItem>*/}
              {isAuthenticated && <DropdownItem onClick={()=>doLogout()}><i className="fa fa-lock"></i> Logout</DropdownItem>}
            </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>
        {/*<AppAsideToggler className="d-md-down-none" />*/}
        {/*<AppAsideToggler className="d-lg-none" mobile />*/}
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

export default withAuth0(DefaultHeader);
